/* Core imports */
import { withI18n } from 'react-i18next';
import { connect } from 'react-redux';

/* Redux content */
import {
  isLoggedInSel,
  shouldSelectAccountSel,
  signInPendingSel,
  signinFailedSel,
  signinErrorSel,
  signInActions,
  shouldVerifySel,
  shouldUpdateInfoSel,
  samsungUserSel
} from 'src/store/modules/signin';

import { accountSpecialUserSel, userDataSel } from 'src/store/modules/user';

import SignInView from './SignInView';

const mapStateToProps = (state: any) => {
  return {
    shouldSelectAccount: shouldSelectAccountSel(state),
    shouldVerify: shouldVerifySel(state),
    shouldUpdateInfo: shouldUpdateInfoSel(state),
    isLoggedIn: isLoggedInSel(state),
    signinFailed: signinFailedSel(state),
    signinError: signinErrorSel(state),
    pending: signInPendingSel(state),
    specialUser: accountSpecialUserSel(state),
    userData: userDataSel(state),
    isSamsungUser: samsungUserSel(state)
  };
};

const mapDispatchToProps = (dispatch: any): IDispatchFromProps => ({
  login: (username: string, password: string) =>
    dispatch(signInActions.signin(username, password))
});

export const pureComponent = SignInView;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withI18n()(SignInView));

interface IDispatchFromProps {
  login(username: string, password: string): void;
}
